import * as types from '../mutation-types';

const initialState = {
  tabs: [],
};

const tabs = { ...initialState };

const getters = {
  tabs: (state) => state.tabs,
};

const actions = {
  addTab(
    { commit, dispatch, getters },
    { name, routeName, path, query, params, meta }
  ) {
    const existingTab = getters.tabs.find((t) => t.name === name);
    if (existingTab) {
      dispatch('updateTab', {
        name,
        routeName,
        path,
        query,
        params,
        meta,
      });
    } else {
      commit(types.ADD_TAB, {
        name,
        routeName,
        path,
        query,
        params,
        meta,
      });
    }
  },
  removeTab({ commit }, name) {
    commit(types.REMOVE_TAB, name);
  },
  updateTab({ commit }, { name, routeName, path, query, params, meta }) {
    commit(types.UPDATE_TAB, {
      name,
      routeName,
      path,
      query,
      params,
      meta,
    });
  },
  purgeTabs({ commit }) {
    commit(types.PURGE_TABS);
  },
};

const mutations = {
  [types.ADD_TAB](state, { name, routeName, path, query, params, meta }) {
    state.tabs = [
      ...state.tabs,
      {
        name,
        routeName,
        path,
        query,
        params,
        meta,
      },
    ];
  },
  [types.REMOVE_TAB](state, name) {
    const tabIndex = state.tabs.findIndex((t) => t.name === name);
    state.tabs.splice(tabIndex, 1);
  },
  [types.UPDATE_TAB](state, { name, routeName, path, query, params, meta }) {
    const tabIndex = state.tabs.findIndex((t) => t.name === name);
    state.tabs.splice(tabIndex, 1, {
      name,
      routeName,
      path,
      query: { ...query },
      params: { ...params },
      meta: { ...meta },
    });
  },
  [types.PURGE_TABS](state) {
    state.tabs = [];
  },
};

export default {
  state: tabs,
  getters,
  actions,
  mutations,
};
